import { Component, Input } from '@angular/core';

import { ShListRowTitleComponent } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { LinkCell } from './link-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-link-cell',
    templateUrl: './link-cell.component.html',
    imports: [ShListRowTitleComponent]
})
export class ShLinkCellComponent extends ShBaseCell {
    @Input() public cell!: LinkCell;
}
